import * as React from 'react';

import { Service, Default } from '@crochik/pi-react/context';
import { RequestError } from '@crochik/pi-react/api';
import ErrorService from '@crochik/pi-react/services/ErrorService';

export enum ExceptionType {
    Token,
    Slots,
    Post,
    MissingQueryParams,
    Other
}

export class Exception extends Service {
    raise(type: ExceptionType, e?: any, other?: any) {
        var msg = (e instanceof RequestError) ? `Error: ${e.error}: ${e.status}` : e;
        var title = `Exception ${type}`;
        ErrorService().message(msg, true, title, undefined);
    }
}

class ExceptionImpl extends Service {
    raise(type: ExceptionType, e?: any, other?: any) {
        var title;
        var msg;
        var critical = true;
        var onClose: (() => any) | undefined = undefined;

        switch (type) {
            case ExceptionType.Token:
                title = 'Service Not Available';
                if (e instanceof RequestError) {
                    msg = (
                        <span>
                            <p>We are sorry for the inconvenience.<br />
                                Please try again in a few minutes call us using the phone number on our website.</p>
                            <p>Error #{e.error}</p>
                        </span>
                    );
                } else {
                    msg = (
                        <span>
                            <p>We are sorry for the inconvenience.<br />
                                Please try again in a few minutes or call us using the phone number on our website.</p>
                        </span>
                    );
                }
                break;

            case ExceptionType.Slots:
                if (e instanceof RequestError) {
                    msg = `No slots available (#${e.error})`;
                } else {
                    msg = 'No slots available';
                }
                title = undefined;
                critical = false;
                break;

            case ExceptionType.Post:
                if (e instanceof RequestError) {
                    msg = (
                        <span>
                            <p>We are sorry for the inconvenience.<br />
                                I am having problems contacting the server,
                                please call us using the phone number on our website.</p>
                            <p>Error #{e.error}</p>
                        </span>
                    );
                } else {
                    msg = (
                        <span>
                            <p>We are sorry for the inconvenience.<br />
                                I am having problems contacting the server,
                                please call us using the phone number on our website.</p>
                        </span>
                    );
                }
                title = 'Scheduling Error';
                break;

            case ExceptionType.MissingQueryParams:
                title = 'Missing Required Parameters';
                msg = 'Can\'t continue. Missing required parameters';
                onClose = () => { window.location.href = 'https://www.floorcoveringsinternational.com'; };
                break;

            default:
                break;
        }

        ErrorService().message(msg, critical, title, onClose);
    }
}

export function register() {
    Default.services.register(Exception, new ExceptionImpl());
}

export default function get(): Exception {
    return Default.services.getService(Exception);
}


// WEBPACK FOOTER //
// ./src/app/services/Exception.tsx